module.exports = __webpack_public_path__ + "build_icon.b1472186b995f56faaa0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/build_icon.svg
// module id = 1404
// module chunks = 3